import { useNetwork } from 'ahooks';
import { type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
// import Dialog from '@/components/dialog';
import { useChatContext } from '@/contexts/chat/context';
import ChatHeaderMediaCall from '../chat-header-media-call';
import styles from './index.module.scss';
import MoreToolIcon from './images/more.svg?react';

const ChatHeaderOperation = ({ chat }: { chat: Chat }) => {
  const [openSetting, setOpenSetting] = useState(false);
  const { mediaCallSingle, chatMediaCall } = useChatContext();
  const { online } = useNetwork();

  const handleOpenSetting = () => {
    console.log('openSetting', openSetting, chat);
    setOpenSetting(true);

    message.info('Coming soon.');

    // Dialog({
    //   title: 'Coming Soon',
    //   content: 'This feature is not available yet.',
    //   onConfirm: () => {
    //     return new Promise((resolve) => {
    //       setTimeout(() => {
    //         resolve(true);
    //       }, 10);
    //     });
    //   },
    //   onCancel: () => {
    //     setOpenSetting(false);
    //   },
    // });
  };

  const sendMediaCall = useCallback(
    (item: { key: string }) => {
      if (!online) {
        message.error('Network error.');
        return;
      }
      mediaCallSingle({ chat_id: chat.chat_id, payload_type: Number(item.key) });
    },
    [online, mediaCallSingle, chat.chat_id]
  );

  return (
    <>
      <div className={styles.operationBar}>
        <ChatHeaderMediaCall
          onClick={sendMediaCall}
          chatMediaCall={chatMediaCall}
        ></ChatHeaderMediaCall>
        <div className={styles.settings} onClick={handleOpenSetting}>
          <MoreToolIcon />
        </div>
      </div>
    </>
  );
};

export default ChatHeaderOperation;
